/*
  Conteúdo do portfólio da Morgana.

  Para adicionar, trocar ou remover um vídeo, mexa SÓ neste arquivo:
   1. coloque o .mp4 em  public/videos/<slug>.mp4
   2. o frame de capa em public/videos/posters/<slug>.jpg
   3. a prévia muda de 6s em public/videos/previews/<slug>.mp4  (opcional)
   4. adicione o objeto na lista da categoria certa

  orientation: 'vertical' (9:16) ou 'horizontal' (16:9) — define o corte do card
  e o formato do player. duration é em segundos, só para o selo de tempo.
  credits: exigência da liberação de direito de imagem — marca + modelo.
*/

const v = (slug) => ({
  video: `/videos/${slug}.mp4`,
  poster: `/videos/posters/${slug}.jpg`,
  preview: `/videos/previews/${slug}.mp4`,
});

/* ───────────────────────── FASHION FILM ───────────────────────── */
export const fashionFilmProjects = [
  {
    id: 'bk-sofia-ana',
    ...v('bk-sofia-ana'),
    title: 'Editorial de Coleção',
    client: 'BK',
    description:
      'Editorial de estúdio com duas modelos, construído em torno de uma paleta terrosa e de texturas — cerâmica, couro e metal. Direção de movimento pensada para alternar plano aberto de look e detalhe de acabamento.',
    role: 'Direção, captação e color grading',
    tags: ['Fashion Film', 'Editorial', 'Estúdio'],
    credits: 'Marca: BK · Modelos: Sofia Guedes e Ana Melo',
    orientation: 'vertical',
    duration: 24.8,
    rotation: -1.2,
  },
  {
    id: 'bk-sofia-1',
    ...v('bk-sofia-1'),
    title: 'Look Terracota',
    client: 'BK',
    description:
      'Peça de coleção apresentada em cenário de arcos e luz quente. O corte acompanha o caimento do tecido e fecha nos detalhes de metal e fivela.',
    role: 'Direção, captação e color grading',
    tags: ['Fashion Film', 'Editorial', 'Estúdio'],
    credits: 'Marca: BK · Modelo: Sofia Guedes',
    orientation: 'vertical',
    duration: 23.7,
    rotation: 1.0,
  },
  {
    id: 'bk-sofia-2',
    ...v('bk-sofia-2'),
    title: 'Conjunto Jeans',
    client: 'BK',
    description:
      'Look em jeans registrado em movimento — o caimento da saia longa e o volume do tecido conduzem o ritmo do vídeo.',
    role: 'Direção, captação e color grading',
    tags: ['Fashion Film', 'Editorial', 'Movimento'],
    credits: 'Marca: BK · Modelo: Sofia Guedes',
    orientation: 'vertical',
    duration: 21.1,
    rotation: -0.8,
  },
  {
    id: 'bk-making-of',
    ...v('bk-making-of'),
    title: 'Making Of',
    client: 'BK',
    description:
      'Bastidores da produção: seleção de peças, prova de look, camarim e equipe em ação. Material pensado para humanizar a marca e alimentar o feed entre os lançamentos.',
    role: 'Direção, captação e edição',
    tags: ['Making Of', 'Bastidores', 'Editorial'],
    credits: 'Marca: BK · Modelos: Sofia Guedes e Ana Melo',
    orientation: 'vertical',
    duration: 53.2,
    rotation: 1.3,
  },
  {
    id: 'ec-making-of',
    ...v('ec-making-of'),
    title: 'Making Of de Campanha',
    client: 'EC',
    description:
      'Registro do set de campanha — preparação de beleza, teste de luz, acompanhamento no monitor e a modelo em cena. Um recorte de como a imagem final é construída.',
    role: 'Direção, captação e edição',
    tags: ['Making Of', 'Campanha', 'Beleza'],
    credits: 'Marca: EC · Modelo: Serenna Leite',
    orientation: 'horizontal',
    duration: 56.8,
    rotation: -1.5,
  },
  {
    id: 'metro-abertura',
    ...v('metro-abertura'),
    title: 'Abertura de Coleção',
    client: 'Metro',
    description:
      'Abertura da coleção com carro clássico em estúdio. Animal print, dourado e marrom em contraste com fundo claro — os detalhes de tecido abrem e fecham a peça.',
    role: 'Direção, captação e color grading',
    tags: ['Fashion Film', 'Coleção', 'Estúdio'],
    credits: 'Marca: Metro · Modelo: Camilla Santos',
    orientation: 'vertical',
    duration: 68.2,
    rotation: 0.9,
  },
  {
    id: 'metro-camilla',
    ...v('metro-camilla'),
    title: 'Look Brilho',
    client: 'Metro',
    description:
      'Look de brilho apresentado com luz dura e reflexo controlado, explorando o comportamento do bordado em movimento.',
    role: 'Direção, captação e color grading',
    tags: ['Fashion Film', 'Editorial', 'Movimento'],
    credits: 'Marca: Metro · Modelo: Camilla Santos',
    orientation: 'vertical',
    duration: 23.3,
    rotation: -1.1,
  },
  {
    id: 'ninna-ana',
    ...v('ninna-ana'),
    title: 'Look Clean',
    client: 'Ninna',
    description:
      'Composição clara e minimalista — listrado, alfaiataria branca e cenografia de degraus. O movimento de câmera é curto e seco, no ritmo do look.',
    role: 'Direção, captação e color grading',
    tags: ['Fashion Film', 'Minimalista', 'Estúdio'],
    credits: 'Marca: Ninna · Modelo: Ana Melo',
    orientation: 'vertical',
    duration: 23.5,
    rotation: 1.2,
  },
  {
    id: 'ninna-paula',
    ...v('ninna-paula'),
    title: 'Camisaria & Animal Print',
    client: 'Ninna',
    description:
      'Camisa branca sobre saia estampada, em cenário neutro. Fechamentos em detalhe de cinto, acessório e caimento da barra.',
    role: 'Direção, captação e color grading',
    tags: ['Fashion Film', 'Editorial', 'Estúdio'],
    credits: 'Marca: Ninna · Modelo: Paula Galvão',
    orientation: 'vertical',
    duration: 21.5,
    rotation: -0.7,
  },
];

/* ───────────────────────── REDE SOCIAL ───────────────────────── */
export const redeSocialProjects = [
  {
    id: 'nick-nails-antes-depois',
    ...v('nick-nails-antes-depois'),
    title: 'Antes & Depois',
    client: '@studio_nick.nails',
    description:
      'Processo completo de nail design, do preparo ao resultado. Formato pensado para reter até o final — a transformação só se fecha no último plano.',
    role: 'Captação e edição',
    tags: ['Reels', 'Antes e Depois', 'Beleza'],
    credits: 'Cliente: @studio_nick.nails',
    orientation: 'horizontal',
    duration: 60.9,
    rotation: -1.0,
  },
  {
    id: 'nick-nails-favoritas',
    ...v('nick-nails-favoritas'),
    title: 'Favoritas do Mês',
    client: '@studio_nick.nails',
    description:
      'Formato de depoimento com legendas na tela: a cliente comenta as unhas favoritas do mês enquanto os trabalhos aparecem em detalhe. Conteúdo de prova social para o feed.',
    role: 'Captação, edição e legendas',
    tags: ['Reels', 'Depoimento', 'Beleza'],
    credits: 'Cliente: @studio_nick.nails',
    orientation: 'vertical',
    duration: 87.3,
    rotation: 1.2,
  },
  {
    id: 'concretizar',
    ...v('concretizar'),
    title: 'Concreto com Compromisso',
    client: 'Concretizar',
    description:
      'Institucional de obra em formato vertical: bombeamento de concreto, equipe em campo e legendas de apoio conduzindo a mensagem até a assinatura da marca.',
    role: 'Captação, edição e legendas',
    tags: ['Reels', 'Institucional', 'Obra'],
    credits: 'Cliente: Concretizar',
    orientation: 'vertical',
    duration: 35.3,
    rotation: -0.7,
  },
  {
    id: 'reel-02',
    ...v('reel-02'),
    title: 'Projeto JUMP',
    client: 'JUMP',
    description:
      'Vídeo de apresentação do projeto, com apresentadora em estúdio, legendas de destaque e chamada final para inscrição.',
    role: 'Captação, edição e legendas',
    tags: ['Institucional', 'Legendas', 'Conversão'],
    credits: 'Cliente: JUMP',
    orientation: 'vertical',
    duration: 121.2,
    rotation: 1.4,
  },
  {
    id: 'reel-01',
    ...v('reel-01'),
    title: 'Último Sábado do Ano',
    client: 'Evento',
    description:
      'Aftermovie de festa em preto e branco, com granulação e câmera solta. Corte no ritmo da música para circular no feed logo depois do evento.',
    role: 'Captação e edição',
    tags: ['Aftermovie', 'Evento', 'P&B'],
    orientation: 'vertical',
    duration: 16.9,
    rotation: -1.3,
  },
];

/* ─────────────────── COMERCIAL E OUTROS ─────────────────── */
export const comercialProjects = [
  {
    id: 'nicole-e-guilherme',
    ...v('nicole-e-guilherme'),
    title: 'Nicole & Guilherme',
    client: 'Casamento',
    description:
      'Filme de casamento: preparação da noiva, cerimônia e a reação dos convidados. Narrativa construída a partir dos detalhes e dos momentos que não se repetem.',
    role: 'Direção, captação e edição',
    tags: ['Casamento', 'Documental', 'Evento'],
    orientation: 'horizontal',
    duration: 182.6,
    rotation: -1.1,
  },
  {
    id: 'mutirao-de-grafite',
    ...v('mutirao-de-grafite'),
    title: 'Mutirão de Grafite',
    client: 'Ação cultural',
    description:
      'Registro de um mutirão de grafite: o muro em branco, o traço sendo construído e o resultado coletivo. Documentação de ação cultural na rua.',
    role: 'Captação e edição',
    tags: ['Documentário', 'Arte Urbana', 'Comunidade'],
    orientation: 'horizontal',
    duration: 136.1,
    rotation: 1.0,
  },
];

/* ───────────────────────── HOME ───────────────────────── */
export const homeData = {
  name: 'MORGANA',
  tagline: 'FILMMAKER & ESTRATEGISTA DE CONTEÚDO',
  about:
    'Unindo a estética do audiovisual com a inteligência do marketing, atuo na criação de narrativas visuais que capturam a essência de marcas e projetos. Com foco em Produções de Moda, domino todas as etapas da produção: da direção criativa à pós-produção e color grading. Meu trabalho transita entre o refinamento editorial da moda, o ritmo do conteúdo para redes sociais e a sensibilidade documental de eventos e projetos culturais. Não entrego apenas vídeos; entrego ferramentas de comunicação que conectam marcas a pessoas e transformam momentos em memórias visuais.',
  profileImage: '/img/morgana-perfil.webp',
  contact: {
    email: 'morgana@filmmaker.com',
    instagram: 'morgana.sy',
    instagramUrl: 'https://www.instagram.com/morgana.sy/',
    whatsapp: '+55 37 98416-2121',
  },
  decisionCards: [
    {
      id: 'fashion',
      title: 'Fashion Film',
      subtitle: 'Estética · Direção de Arte · Color Grading',
      description: 'Narrativas visuais de alta estética para marcas de moda e campanhas editoriais.',
      link: '/fashion-film',
      thumbnail: '/img/capa-fashion.jpg',
    },
    {
      id: 'social',
      title: 'Rede Social',
      subtitle: 'Ritmo · Gancho · Retenção',
      description: 'Reels verticais que prendem a atenção e comunicam a marca em segundos.',
      link: '/rede-social',
      thumbnail: '/img/capa-social.jpg',
    },
    {
      id: 'comercial',
      title: 'Comercial e Outros',
      subtitle: 'Registro · Documentação · Eventos',
      description: 'Casamentos, eventos e ações culturais registrados com olhar documental.',
      link: '/comercial',
      thumbnail: '/img/capa-comercial.jpg',
    },
  ],
};
